import { Client } from "../entities";

const mockClient: Client = {
  name: "Home",
  logo: "EARTHLY",
  isApiClient: false,
};

export default mockClient;
